export const MINIMUM_SIGNUP_AGE = 18;
export const VIEWPORT_WIDTH_DESKTOP = 767;
